module.exports = __webpack_public_path__ + "img/c_v3.e6c9f24.png";